import React, { useEffect, useState } from "react";
import "./style/finalizeStyle.css";
import "./style/style.scss";
import "../../../style/hovers.scss";
import useFinalizeManager from "./hooks/useFinalizeManager";
import FinalizeWithLogin from "./FinalizeWithLogin";
import FinalizeNoLogin from "./FinalizeNoLogin";
import "./style/style.scss";
import BasketFirstStep from "./BasketFirstStep";
import BasketSecondStep from "./BasketSecondStep";
import useBasketManager from "../SaleMovie/CinemaHall/hooks/useBasketManager";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../store";
import { useTranslation } from "react-i18next";
import { getUserDataByToken } from "../../store/auth/authActions";
import { GET_USER_DATA_URL } from "../../api/apiRoutes";
import useFacility from "../../../utils/hooks/useFacility";

const FinalizePage: React.FC = () => {
  const { getBasket, basket, deletePromotions, total, promoCode, promoMessage } = useBasketManager();
  const { t } = useTranslation();
  const userData = useSelector((state: State) => state.auth.userData);
  const { acceptTransaction, alert, onRemoveItemFromBasket, paymentUrl, loader, saveReservation } =
    useFinalizeManager();
  const info = useSelector((state: State) => state.alerts.info);
  const basketLength = useSelector((state: State) => state.basket.basketLength);
  let [step, setStep] = useState(1);
  const dispatch = useDispatch();
  const facilityIds = useFacility();
  const handleSetStep = (step: number) => {
    setStep(step);
  };

  useEffect(() => {
    getBasket();

    if (!userData) {
      dispatch(getUserDataByToken(GET_USER_DATA_URL(facilityIds)));
    }
  }, [info]);

  useEffect(() => {
    getBasket();
    deletePromotions();
  }, [basketLength]);

  const handlePromotion = (promotionCode: string) => {
    promoCode(promotionCode);
  };

  const handleDelete = (index: number) => {
    onRemoveItemFromBasket(index);
    setTimeout(() => {
      getBasket();
    }, 800);
  };

  const handleGetBasket = () => {
    setTimeout(() => {
      getBasket();
    }, 800);
  };

  return (
    <React.Fragment>
      <div className="basket-container">
        <div className="basket-steps flex-start-center">
          <div className="active step flex-start-center" onClick={() => setStep(1)}>
            <b className="flex-center-center">1</b>
            <span className="move-up">{t("podsumowanie_koszyka")}</span>
          </div>

          <div
            onClick={() => {
              if (step === 2 || step === 3) {
                setStep(2);
              }
            }}
            className={
              step === 2 || step === 3 || step === 4 ? "active step flex-start-center" : "step flex-start-center"
            }
          >
            <b className="flex-center-center">2</b>
            <span className="move-up">{t("dane_kupujacego")}</span>
          </div>

          <div className={step === 3 || step === 4 ? "active step flex-start-center" : "step flex-start-center"}>
            <b className="flex-center-center">3</b>
            <span className="move-up">{t("platnosc")}</span>
          </div>
        </div>

        {step === 1 && (
          <BasketFirstStep
            promoMessage={promoMessage}
            handlePromotion={handlePromotion}
            handleGetBasket={handleGetBasket}
            handleDelete={handleDelete}
            setStep={handleSetStep}
            basket={basket}
            total={total}
          />
        )}
        {step === 2 && <BasketSecondStep setStep={handleSetStep} />}
        {step === 3 && (
          <FinalizeNoLogin
            alert={alert}
            onPayTransaction={acceptTransaction}
            onSaveReservation={saveReservation}
            total={total}
            paymentUrl={paymentUrl}
            loader={loader}
          />
        )}
        {step === 4 && (
          <FinalizeWithLogin
            alertPayment={alert}
            onPayTransaction={acceptTransaction}
            onSaveReservation={saveReservation}
            total={total}
            paymentUrl={paymentUrl}
            loader={loader}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FinalizePage;
